module.exports = __webpack_public_path__ + "static/cafe1-3332a316ab7e0c8cc6d09c3ed8e5ad80.jpg";